import { useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";

import { BaseTableData } from "../types";

interface UseColumnsFitProps<T extends BaseTableData> {
  gridRef?: React.RefObject<AgGridReact<T>>;
  gridContainerRef: React.RefObject<HTMLDivElement>;
}

export const useColumnsFit = <T extends BaseTableData>({
  gridRef,
  gridContainerRef,
}: UseColumnsFitProps<T>) => {
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    const container = gridContainerRef.current;

    if (!container) {
      return;
    }

    resizeObserverRef.current = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        if (gridRef?.current?.api) {
          gridRef.current.api.sizeColumnsToFit();
        }
      });
    });

    resizeObserverRef.current.observe(container);

    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
        resizeObserverRef.current = null;
      }
    };
  }, [gridRef, gridContainerRef]);

  useEffect(
    () => () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    },
    [],
  );
};
